import React from 'react';
import {Edit, List} from 'components';
import {useNamedSelector} from 'helpers';

export function WealthGoalActions() {
  const goal = useNamedSelector('clarity.goals', { category: 'wealth-&-finances' });
  const activities = useNamedSelector('clarity.activities', { category: 'wealth-&-finances' });
  return (
    <List tiny-gutter>
      <p>Where would you like to be in one year with regards to your finances (e.g. double your savings, put $10,000 in an education fund for your children, eliminate additional debt, earn 20% more, etc.). Choose one specific goal.</p>
      <Edit value={goal.name} setValue={goal.update} />
      <List.Title>What can you do to achieve your goal? Make a plan and schedule the specific actions you need to take and commit to taking them.</List.Title>
      <Edit name="0" value={activities.first} setValue={activities.update} />
      <Edit name="1" value={activities.second} setValue={activities.update} />
    </List>
  );
}
